import { render, staticRenderFns } from "./logisInboundListV0.vue?vue&type=template&id=441f96ac&scoped=true"
import script from "./logisInboundListV0.vue?vue&type=script&lang=js"
export * from "./logisInboundListV0.vue?vue&type=script&lang=js"
import style0 from "./logisInboundListV0.vue?vue&type=style&index=0&id=441f96ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "441f96ac",
  null
  
)

export default component.exports